import { AGENT_TRACKER_ROLE } from "vue-app/types/enums";

export const dashboardRoutes = [
  {
    path: "/app/dashboard/general",
    component: () => import("../../../../vue-app/pages/PageDashboardGeneral.vue"),
    props: (route) => ({
      dateFrom: route.query.from,
      dateTo: route.query.to,
    }),
    meta: {
      routeName: window.$_t("REPORTS"),
      skipGlobalLoader: true,
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_REPORTS],
    },
  },
  {
    path: "/app/dashboard/engagements/email",
    component: () => import("../../../../vue-app/pages/PageDashboardEngagements.vue"),
    props: (route) => ({
      dateFrom: route.query.from,
      dateTo: route.query.to,
      channelTypeId: 1,
    }),
    meta: {
      routeName: window.$_t("REPORTS"),
      skipGlobalLoader: true,
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_REPORTS],
    },
  },
  {
    path: "/app/dashboard/engagements/sms",
    component: () => import("../../../../vue-app/pages/PageDashboardEngagements.vue"),
    props: (route) => ({
      dateFrom: route.query.from,
      dateTo: route.query.to,
      channelTypeId: 2,
    }),
    meta: {
      routeName: window.$_t("REPORTS"),
      skipGlobalLoader: true,
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_REPORTS],
    },
  },
  {
    path: "/app/dashboard/engagements/whatsapp",
    component: () => import("../../../../vue-app/pages/PageDashboardEngagements.vue"),
    props: (route) => ({
      dateFrom: route.query.from,
      dateTo: route.query.to,
      channelTypeId: 16,
    }),
    meta: {
      routeName: window.$_t("REPORTS"),
      skipGlobalLoader: true,
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_REPORTS],
    },
  },
  {
    path: "/app/dashboard/onsite",
    component: () => import("../../../../vue-app/pages/PageDashboardOnsite.vue"),
    name: "app-dashboard-onsite",
    props: (route) => ({
      dateFrom: route.query.from,
      dateTo: route.query.to,
    }),
    meta: {
      routeName: window.$_t("REPORTS"),
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_REPORTS],
      skipGlobalLoader: true,
    },
  },
  {
    path: "/app/dashboard/inbox",
    component: () => import("../../../../vue-app/pages/PageDashboardInbox.vue"),
    props: (route) => ({
      dateFrom: route.query.from,
      dateTo: route.query.to,
    }),
    meta: {
      routeName: window.$_t("REPORTS"),
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_REPORTS],
      skipGlobalLoader: true,
    },
  },
];
